/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Request_NewInputs */

const cs_auth_reset_request_new = /** @type {(inputs: Auth_Reset_Request_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Požádat o nový odkaz`)
};

const en_auth_reset_request_new = /** @type {(inputs: Auth_Reset_Request_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request a new reset link`)
};

/**
* | output |
* | --- |
* | "Request a new reset link" |
*
* @param {Auth_Reset_Request_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_request_new = /** @type {((inputs?: Auth_Reset_Request_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Request_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_request_new(inputs)
	return cs_auth_reset_request_new(inputs)
});